import { store } from '@redux/store';
import getLoginURL from './getLoginURL';
import authTypes from './Constants';

export const REDIRECT_TO = 'redirectTo';
export const BASE_URL = '/';

/**
 * Sets the from string to local storage, to be used with SSO login
 * @param from string - where the user is coming from
 */
export const setRedirectToLocalStorage = (from: string) => {
  localStorage.setItem(REDIRECT_TO, from);
};

export const removeRedirectToFromLocalStorage = () => {
  localStorage.removeItem(REDIRECT_TO);
};

export const getRedirectToFromLocalStorage = (): string | null => {
  return localStorage.getItem(REDIRECT_TO);
};

/**
 * getRedirectToUrl()
 * For SSO:
 * 1. sets where the user is coming from to local storage
 * 2. returns the appropriate loginUrl
 *
 * For non-SSO:
 * 1. appends the "redirectTo" query param to the loginUrl if coming from anywhere other than /
 *
 * @param {string} loginUrl
 * @returns string
 */
export const getRedirectToUrl = () => {
  const from = window.location.pathname + window.location.search;
  const loginUrl = getLoginURL(false);

  // For SSO:
  // - Handle setting where the user is coming from
  // - return the loginUrl
  const state = store.getState();
  if (state.userInfo.authType !== authTypes.db) {
    setRedirectToLocalStorage(from);
    return loginUrl;
  }

  // For non-SSO:
  // - return the loginUrl w/a redirectTo query param
  const redirectTo = from !== BASE_URL ? `?${REDIRECT_TO}=${encodeURIComponent(from)}` : '';
  return `${loginUrl}${redirectTo}`;
};
